const AppTypes = require("../action-types/snackbar");

const internals = {
    initial: () => ({
        message: "",
        open: false
    })
};

module.exports = (state, action) => {
    state = state || internals.initial();

    const { payload, type } = action;

    switch (type) {
        case AppTypes.SNACKBAR_MESSAGE:
            return {
                ...state,
                message: payload.message,
                open: true
            };

        case AppTypes.SNACKBAR_HIDE:
            return {
                ...state,
                message: "",
                open: false
            };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/snackbar.js